import { Button } from "@/components";
import { Text } from "@/design-system";
import { t } from "@/context/language";
import { motion } from "framer-motion";
import { HeroPaymentsCard } from "./heroPaymentsCard";

type HeroSectionProps = {
  onCtaClick: () => void;
};

export function HeroSection({ onCtaClick }: HeroSectionProps) {

  return (
    <div className="flex min-h-screen items-center pt-24 pb-12 lg:pt-28">
      <div className="grid w-full grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12">
        <div className="flex flex-col gap-6 text-left lg:gap-8">
          {/* h1 renderizado estático (sem fade) — é o elemento de LCP do hero;
              animar opacity atrasaria a pintura e penaliza Core Web Vitals. */}
          <h1 id="hero-title" className="text-title-xl font-bold leading-[1.08] text-black">
            {t.hero.title}
          </h1>

          <motion.p
            className="max-w-[460px] text-base text-gray-700"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          >
            {t.hero.subtitle}
          </motion.p>

          <motion.div
            className="flex w-full flex-col items-center gap-3 sm:w-fit"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
          >
            <motion.div className="w-full sm:w-auto" whileTap={{ scale: 0.97 }}>
              <Button
                className="h-auto min-h-12 w-full rounded-full px-7 py-3 text-center text-base whitespace-normal sm:w-auto"
                onClick={onCtaClick}
              >
                {t.hero.cta}
              </Button>
            </motion.div>
            <Text size="small" tone="subtle" className="text-center">
              {t.hero.ctaNote}
            </Text>
          </motion.div>
        </div>

        <motion.div
          className="flex justify-center lg:justify-end"
          initial={{ opacity: 0, scale: 0.9, y: 30 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          <HeroPaymentsCard />
        </motion.div>
      </div>
    </div>
  );
}
